import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import EmptyCells from "./EmptyCells";
import { leftCellSx, rightCellSx, rowSx } from "./tableStyles";
import { STATIC_STRINGS } from "@asez/shared";

const AddQuestionRow = ({ topicIndex, setNewQuestion, setModalOpen }) => {
  return (
    <TableRow sx={rowSx}>
      <TableCell
        sx={{
          ...leftCellSx,
          borderBottom: 1,
          borderLeft: 1,
          borderColor: "var(--color-table-header)",
        }}
      ></TableCell>
      <EmptyCells />
      <TableCell
        align="center"
        sx={{
          ...rightCellSx,
          borderRight: 1,
          borderColor: "var(--color-table-header)",
        }}
      >
        <button
          className="btn btn-outline p-1 xl:p-2 shadow-md w-20"
          onClick={() => {
            setNewQuestion((p) => ({ ...p, index: topicIndex }));
            setModalOpen("open");
          }}
        >
          {STATIC_STRINGS.ADD_TYPE}
        </button>
      </TableCell>
    </TableRow>
  );
};

export default AddQuestionRow;
